import * as e from "zod";
//#region src/apiUrls.ts
var t = "https://address.api.myparcel.nl", n = "https://address.api.acceptance.myparcel.nl", r = {
	type: "string",
	enum: /* @__PURE__ */ "AL.AK.AZ.AR.CA.CO.CT.DE.FL.GA.HI.ID.IL.IN.IA.KS.KY.LA.ME.MD.MA.MI.MN.MS.MO.MT.NE.NV.NH.NJ.NM.NY.NC.ND.OH.OK.OR.PA.RI.SC.SD.TN.TX.UT.VT.VA.WA.DC.WV.WI.WY".split("."),
	examples: ["AL", "WY"]
}, i = {
	type: "string",
	enum: [
		"AB",
		"BC",
		"MB",
		"NB",
		"NL",
		"NS",
		"NT",
		"NU",
		"ON",
		"PE",
		"SK",
		"QC",
		"YT"
	],
	examples: ["AB", "YT"]
}, a = {
	oneOf: [
		{
			type: "object",
			properties: {
				city: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "City name."
				},
				postalCode: {
					type: "string",
					minLength: 1,
					maxLength: 15,
					description: "Postal code."
				},
				postOfficeBox: {
					type: "boolean",
					description: "Whether the address is a post office box."
				},
				street: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Street name."
				},
				houseNumber: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number."
				},
				latitude: {
					type: "number",
					minimum: -90,
					maximum: 90,
					description: "Geodetic latitude."
				},
				longitude: {
					type: "number",
					minimum: -180,
					maximum: 180,
					description: "Geodetic longitude."
				},
				municipality: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Municipality name."
				},
				countryCode: {
					type: "string",
					enum: ["BE"],
					description: "ISO 3166-1 alpha-2 code."
				},
				boxNumber: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "Bus number, only for Belgian addresses."
				}
			},
			required: [
				"city",
				"postalCode",
				"postOfficeBox",
				"street",
				"countryCode"
			]
		},
		{
			type: "object",
			properties: {
				city: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "City name."
				},
				postalCode: {
					type: "string",
					minLength: 1,
					maxLength: 15,
					description: "Postal code."
				},
				postOfficeBox: {
					type: "boolean",
					description: "Whether the address is a post office box."
				},
				street: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Street name."
				},
				houseNumber: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number."
				},
				latitude: {
					type: "number",
					minimum: -90,
					maximum: 90,
					description: "Geodetic latitude."
				},
				longitude: {
					type: "number",
					minimum: -180,
					maximum: 180,
					description: "Geodetic longitude."
				},
				municipality: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Municipality name."
				},
				countryCode: {
					type: "string",
					enum: /* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split("."),
					description: "ISO 3166-1 alpha-2 code."
				},
				houseNumberSuffix: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number suffix."
				}
			},
			required: [
				"city",
				"postalCode",
				"postOfficeBox",
				"street",
				"countryCode"
			]
		},
		{
			type: "object",
			properties: {
				city: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "City name."
				},
				postalCode: {
					type: "string",
					minLength: 1,
					maxLength: 15,
					description: "Postal code."
				},
				postOfficeBox: {
					type: "boolean",
					description: "Whether the address is a post office box."
				},
				street: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Street name."
				},
				houseNumber: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number."
				},
				latitude: {
					type: "number",
					minimum: -90,
					maximum: 90,
					description: "Geodetic latitude."
				},
				longitude: {
					type: "number",
					minimum: -180,
					maximum: 180,
					description: "Geodetic longitude."
				},
				municipality: {
					type: "string",
					minLength: 1,
					maxLength: 100,
					description: "Municipality name."
				},
				countryCode: {
					type: "string",
					enum: ["NL"],
					description: "ISO 3166-1 alpha-2 code."
				},
				houseNumberSuffix: {
					type: "string",
					minLength: 1,
					maxLength: 25,
					description: "House number suffix."
				}
			},
			required: [
				"city",
				"postalCode",
				"postOfficeBox",
				"street",
				"countryCode"
			]
		}
	],
	examples: [
		{
			city: "Hoofddorp",
			countryCode: "NL",
			houseNumber: "31",
			houseNumberSuffix: "",
			latitude: 52.294862532732346,
			longitude: 4.710693735051177,
			municipality: "Haarlemmermeer",
			postalCode: "2132JE",
			postOfficeBox: !1,
			street: "Antareslaan"
		},
		{
			city: "Amsterdam",
			countryCode: "NL",
			houseNumber: "1",
			houseNumberSuffix: "A1",
			latitude: 52.377778951201,
			longitude: 4.9055895401203,
			municipality: "Amsterdam",
			postalCode: "1000AA",
			postOfficeBox: !0,
			street: "Postbus"
		},
		{
			city: "New York",
			countryCode: "US",
			houseNumber: "767",
			houseNumberSuffix: "",
			latitude: 40.76384629446427,
			longitude: -73.97289035919462,
			municipality: "New York",
			postalCode: "10153",
			postOfficeBox: !1,
			street: "Fifth Avenue"
		}
	]
}, o = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, s = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, c = {
	type: "string",
	enum: /* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split("."),
	description: "ISO 3166-1 alpha-2 code.",
	examples: ["NL", "US"]
}, l = {
	type: "object",
	properties: { valid: { type: "boolean" } },
	required: ["valid"],
	examples: [{ valid: !0 }, { valid: !1 }]
}, u = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var d = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				await f(Math.min(c * 2 ** (p - 1), s ?? 3e4));
			}
		}
	}() };
}, f = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, p = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, m = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, h = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(p(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = f(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : g({
		allowReserved: e,
		name: n,
		value: t
	})).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, g = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, _ = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = m(r), s = Object.entries(i).map(([t, i]) => g({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, v = /\{[^{}]+\}/g, y = ({ path: e, url: t }) => {
	let n = t, r = t.match(v);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, h({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, _({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${g({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, b = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = y({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function x(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var S = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, C = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = h({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = _({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = g({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, w = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, T = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, E = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (T(t, n.name)) continue;
		let e = await S(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, D = (e) => b({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : C(e.querySerializer),
	url: e.url
}), O = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = A(e.headers, t.headers), n;
}, k = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, A = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? k(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, j = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, M = () => ({
	error: new j(),
	request: new j(),
	response: new j()
}), N = C({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), P = { "Content-Type": "application/json" }, F = (e = {}) => ({
	...u,
	headers: P,
	parseAs: "auto",
	querySerializer: N,
	...e
}), I = ((e = {}) => {
	let t = O(F(), e), n = () => ({ ...t }), r = (e) => (t = O(t, e), n()), i = M(), a = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: A(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await E({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: D(n)
		};
	}, o = async (e) => {
		let { opts: t, url: n } = await a(e), r = {
			redirect: "follow",
			...t,
			body: x(t)
		}, o = new Request(n, r);
		for (let e of i.request.fns) e && (o = await e(o, t));
		let s = t.fetch, c;
		try {
			c = await s(o);
		} catch (e) {
			let n = e;
			for (let r of i.error.fns) r && (n = await r(e, void 0, o, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: o,
				response: void 0
			};
		}
		for (let e of i.response.fns) e && (c = await e(c, o, t));
		let l = {
			request: o,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? w(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of i.error.fns) e && (p = await e(f, c, o, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, s = (e) => (t) => o({
		...t,
		method: e
	}), c = (e) => async (t) => {
		let { opts: n, url: r } = await a(t);
		return d({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of i.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: x(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => D({
			...t,
			...e
		}),
		connect: s("CONNECT"),
		delete: s("DELETE"),
		get: s("GET"),
		getConfig: n,
		head: s("HEAD"),
		interceptors: i,
		options: s("OPTIONS"),
		patch: s("PATCH"),
		post: s("POST"),
		put: s("PUT"),
		request: o,
		setConfig: r,
		sse: {
			connect: c("CONNECT"),
			delete: c("DELETE"),
			get: c("GET"),
			head: c("HEAD"),
			options: c("OPTIONS"),
			patch: c("PATCH"),
			post: c("POST"),
			put: c("PUT"),
			trace: c("TRACE")
		},
		trace: s("TRACE")
	};
})(F({
	baseUrl: "https://address.api.myparcel.nl",
	throwOnError: !0
})), L = e.enum(/* @__PURE__ */ "AL.AK.AZ.AR.CA.CO.CT.DE.FL.GA.HI.ID.IL.IN.IA.KS.KY.LA.ME.MD.MA.MI.MN.MS.MO.MT.NE.NV.NH.NJ.NM.NY.NC.ND.OH.OK.OR.PA.RI.SC.SD.TN.TX.UT.VT.VA.WA.DC.WV.WI.WY".split(".")), R = e.enum([
	"AB",
	"BC",
	"MB",
	"NB",
	"NL",
	"NS",
	"NT",
	"NU",
	"ON",
	"PE",
	"SK",
	"QC",
	"YT"
]), z = e.union([
	e.object({
		city: e.string().min(1).max(100).register(e.globalRegistry, { description: "City name." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().min(1).max(100).register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().min(1).max(100).register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.enum(["BE"]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		boxNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "Bus number, only for Belgian addresses." }).optional()
	}),
	e.object({
		city: e.string().min(1).max(100).register(e.globalRegistry, { description: "City name." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().min(1).max(100).register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().min(1).max(100).register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number suffix." }).optional()
	}),
	e.object({
		city: e.string().min(1).max(100).register(e.globalRegistry, { description: "City name." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().min(1).max(100).register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().min(1).max(100).register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.enum(["NL"]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number suffix." }).optional()
	})
]), B = e.object({
	type: e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().min(1).max(100).register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().min(1).max(5e3).register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), V = B.and(e.object({
	type: e.enum(["urn:problem:invalid-request-syntax"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), H = e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }), U = e.object({ valid: e.boolean() }), W = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		countryCode: H.optional(),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number suffix to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		query: e.string().min(3).max(200).register(e.globalRegistry, { description: "Query string to search for an address. Must be used when `houseNumber` and `postalCode` are not used." }).optional(),
		limit: e.int().gte(1).lte(50).register(e.globalRegistry, { description: "Limit the number of addresses to respond. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional().default(5)
	}).optional()
}), G = e.object({ results: e.array(z).register(e.globalRegistry, { description: "When `countryCode`=`NL` and there is no house number suffix supplied then the result will be all the addresses under that house number, and currently that is under 300. For other countries the result is limited to the default 5 or the specified limit." }) }).register(e.globalRegistry, { description: "Found addresses." }), K = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		countryCode: H,
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code to validate an address with. The postalCode is only used for validation when the country uses a postal code system, otherwise it is ignored." }).optional(),
		city: e.string().min(1).max(100).register(e.globalRegistry, { description: "City to validate an address with. For dutch addresses this is not validated." }).optional(),
		houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number to validate an address with. For dutch addresses this is mandatory." }).optional(),
		houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "House number suffix to validate an address with. For dutch addresses this could be mandatory to identify an apartment." }).optional(),
		boxNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "Bus number to validate an address with, this is only for Belgian addresses (instead of a houseNumberSuffix)" }).optional(),
		region: e.string().min(1).max(100).register(e.globalRegistry, { description: "Region to validate an address with. For dutch addresses this is not validated." }).optional(),
		street: e.string().min(1).max(100).register(e.globalRegistry, { description: "Street to validate an address with. For dutch addresses this is not validated." }).optional(),
		validationType: e.enum(["FORMAT"]).register(e.globalRegistry, { description: "When used it only validates the format of the address. Otherwise its existence is also validated." }).optional()
	})
}), q = U;
e.union([e.enum(/* @__PURE__ */ "AL.AK.AZ.AR.CA.CO.CT.DE.FL.GA.HI.ID.IL.IN.IA.KS.KY.LA.ME.MD.MA.MI.MN.MS.MO.MT.NE.NV.NH.NJ.NM.NY.NC.ND.OH.OK.OR.PA.RI.SC.SD.TN.TX.UT.VT.VA.WA.DC.WV.WI.WY".split(".")), e.string()]), e.union([e.enum([
	"AB",
	"BC",
	"MB",
	"NB",
	"NL",
	"NS",
	"NT",
	"NU",
	"ON",
	"PE",
	"SK",
	"QC",
	"YT"
]), e.string()]);
var J = e.union([
	e.object({
		city: e.string().register(e.globalRegistry, { description: "City name." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.union([e.enum(["BE"]), e.string()]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		boxNumber: e.string().register(e.globalRegistry, { description: "Bus number, only for Belgian addresses." }).optional()
	}),
	e.object({
		city: e.string().register(e.globalRegistry, { description: "City name." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		houseNumberSuffix: e.string().register(e.globalRegistry, { description: "House number suffix." }).optional()
	}),
	e.object({
		city: e.string().register(e.globalRegistry, { description: "City name." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code." }),
		postOfficeBox: e.boolean().register(e.globalRegistry, { description: "Whether the address is a post office box." }),
		street: e.string().register(e.globalRegistry, { description: "Street name." }),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number." }).optional(),
		latitude: e.number().gte(-90).lte(90).register(e.globalRegistry, { description: "Geodetic latitude." }).optional(),
		longitude: e.number().gte(-180).lte(180).register(e.globalRegistry, { description: "Geodetic longitude." }).optional(),
		municipality: e.string().register(e.globalRegistry, { description: "Municipality name." }).optional(),
		countryCode: e.union([e.enum(["NL"]), e.string()]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }),
		houseNumberSuffix: e.string().register(e.globalRegistry, { description: "House number suffix." }).optional()
	})
]);
e.object({
	type: e.union([e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}).and(e.object({
	type: e.union([e.enum(["urn:problem:invalid-request-syntax"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
}));
var Y = e.union([e.enum(/* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split(".")), e.string()]).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 code." }), X = e.object({ valid: e.boolean() });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		countryCode: Y.optional(),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		houseNumberSuffix: e.string().register(e.globalRegistry, { description: "House number suffix to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code to search for an address. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional(),
		query: e.string().register(e.globalRegistry, { description: "Query string to search for an address. Must be used when `houseNumber` and `postalCode` are not used." }).optional(),
		limit: e.int().gte(1).lte(50).register(e.globalRegistry, { description: "Limit the number of addresses to respond. Can only be used when `countryCode`=`NL`. Otherwise ignored." }).optional().default(5)
	}).optional()
});
var Z = e.object({ results: e.array(J).register(e.globalRegistry, { description: "When `countryCode`=`NL` and there is no house number suffix supplied then the result will be all the addresses under that house number, and currently that is under 300. For other countries the result is limited to the default 5 or the specified limit." }) }).register(e.globalRegistry, { description: "Found addresses." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		countryCode: Y,
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code to validate an address with. The postalCode is only used for validation when the country uses a postal code system, otherwise it is ignored." }).optional(),
		city: e.string().register(e.globalRegistry, { description: "City to validate an address with. For dutch addresses this is not validated." }).optional(),
		houseNumber: e.string().register(e.globalRegistry, { description: "House number to validate an address with. For dutch addresses this is mandatory." }).optional(),
		houseNumberSuffix: e.string().register(e.globalRegistry, { description: "House number suffix to validate an address with. For dutch addresses this could be mandatory to identify an apartment." }).optional(),
		boxNumber: e.string().register(e.globalRegistry, { description: "Bus number to validate an address with, this is only for Belgian addresses (instead of a houseNumberSuffix)" }).optional(),
		region: e.string().register(e.globalRegistry, { description: "Region to validate an address with. For dutch addresses this is not validated." }).optional(),
		street: e.string().register(e.globalRegistry, { description: "Street to validate an address with. For dutch addresses this is not validated." }).optional(),
		validationType: e.union([e.enum(["FORMAT"]), e.string()]).register(e.globalRegistry, { description: "When used it only validates the format of the address. Otherwise its existence is also validated." }).optional()
	})
});
var Q = X, $ = (e) => (e?.client ?? I).get({
	requestValidator: async (e) => await W.parseAsync(e),
	responseValidator: async (e) => await Z.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/addresses",
	...e
}), ee = (e) => (e.client ?? I).get({
	requestValidator: async (e) => await K.parseAsync(e),
	responseValidator: async (e) => await Q.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/validate",
	...e
}), te = {
	AL: "AL",
	AK: "AK",
	AZ: "AZ",
	AR: "AR",
	CA: "CA",
	CO: "CO",
	CT: "CT",
	DE: "DE",
	FL: "FL",
	GA: "GA",
	HI: "HI",
	ID: "ID",
	IL: "IL",
	IN: "IN",
	IA: "IA",
	KS: "KS",
	KY: "KY",
	LA: "LA",
	ME: "ME",
	MD: "MD",
	MA: "MA",
	MI: "MI",
	MN: "MN",
	MS: "MS",
	MO: "MO",
	MT: "MT",
	NE: "NE",
	NV: "NV",
	NH: "NH",
	NJ: "NJ",
	NM: "NM",
	NY: "NY",
	NC: "NC",
	ND: "ND",
	OH: "OH",
	OK: "OK",
	OR: "OR",
	PA: "PA",
	RI: "RI",
	SC: "SC",
	SD: "SD",
	TN: "TN",
	TX: "TX",
	UT: "UT",
	VT: "VT",
	VA: "VA",
	WA: "WA",
	DC: "DC",
	WV: "WV",
	WI: "WI",
	WY: "WY"
}, ne = {
	AB: "AB",
	BC: "BC",
	MB: "MB",
	NB: "NB",
	NL: "NL",
	NS: "NS",
	NT: "NT",
	NU: "NU",
	ON: "ON",
	PE: "PE",
	SK: "SK",
	QC: "QC",
	YT: "YT"
}, re = {
	AD: "AD",
	AE: "AE",
	AF: "AF",
	AG: "AG",
	AI: "AI",
	AL: "AL",
	AM: "AM",
	AO: "AO",
	AQ: "AQ",
	AR: "AR",
	AS: "AS",
	AT: "AT",
	AU: "AU",
	AW: "AW",
	AX: "AX",
	AZ: "AZ",
	BA: "BA",
	BB: "BB",
	BD: "BD",
	BE: "BE",
	BF: "BF",
	BG: "BG",
	BH: "BH",
	BI: "BI",
	BJ: "BJ",
	BL: "BL",
	BM: "BM",
	BN: "BN",
	BO: "BO",
	BQ: "BQ",
	BR: "BR",
	BS: "BS",
	BT: "BT",
	BV: "BV",
	BW: "BW",
	BY: "BY",
	BZ: "BZ",
	CA: "CA",
	CC: "CC",
	CD: "CD",
	CF: "CF",
	CG: "CG",
	CH: "CH",
	CI: "CI",
	CK: "CK",
	CL: "CL",
	CM: "CM",
	CN: "CN",
	CO: "CO",
	CR: "CR",
	CU: "CU",
	CV: "CV",
	CW: "CW",
	CX: "CX",
	CY: "CY",
	CZ: "CZ",
	DE: "DE",
	DJ: "DJ",
	DK: "DK",
	DM: "DM",
	DO: "DO",
	DZ: "DZ",
	EC: "EC",
	EE: "EE",
	EG: "EG",
	EH: "EH",
	ER: "ER",
	ES: "ES",
	ET: "ET",
	FI: "FI",
	FJ: "FJ",
	FK: "FK",
	FM: "FM",
	FO: "FO",
	FR: "FR",
	GA: "GA",
	GB: "GB",
	GD: "GD",
	GE: "GE",
	GF: "GF",
	GG: "GG",
	GH: "GH",
	GI: "GI",
	GL: "GL",
	GM: "GM",
	GN: "GN",
	GP: "GP",
	GQ: "GQ",
	GR: "GR",
	GS: "GS",
	GT: "GT",
	GU: "GU",
	GW: "GW",
	GY: "GY",
	HK: "HK",
	HM: "HM",
	HN: "HN",
	HR: "HR",
	HT: "HT",
	HU: "HU",
	ID: "ID",
	IE: "IE",
	IL: "IL",
	IM: "IM",
	IN: "IN",
	IO: "IO",
	IQ: "IQ",
	IR: "IR",
	IS: "IS",
	IT: "IT",
	JE: "JE",
	JM: "JM",
	JO: "JO",
	JP: "JP",
	KE: "KE",
	KG: "KG",
	KH: "KH",
	KI: "KI",
	KM: "KM",
	KN: "KN",
	KP: "KP",
	KR: "KR",
	KW: "KW",
	KY: "KY",
	KZ: "KZ",
	LA: "LA",
	LB: "LB",
	LC: "LC",
	LI: "LI",
	LK: "LK",
	LR: "LR",
	LS: "LS",
	LT: "LT",
	LU: "LU",
	LV: "LV",
	LY: "LY",
	MA: "MA",
	MC: "MC",
	MD: "MD",
	ME: "ME",
	MF: "MF",
	MG: "MG",
	MH: "MH",
	MK: "MK",
	ML: "ML",
	MM: "MM",
	MN: "MN",
	MO: "MO",
	MP: "MP",
	MQ: "MQ",
	MR: "MR",
	MS: "MS",
	MT: "MT",
	MU: "MU",
	MV: "MV",
	MW: "MW",
	MX: "MX",
	MY: "MY",
	MZ: "MZ",
	NA: "NA",
	NC: "NC",
	NE: "NE",
	NF: "NF",
	NG: "NG",
	NI: "NI",
	NL: "NL",
	NO: "NO",
	NP: "NP",
	NR: "NR",
	NU: "NU",
	NZ: "NZ",
	OM: "OM",
	PA: "PA",
	PE: "PE",
	PF: "PF",
	PG: "PG",
	PH: "PH",
	PK: "PK",
	PL: "PL",
	PM: "PM",
	PN: "PN",
	PR: "PR",
	PS: "PS",
	PT: "PT",
	PW: "PW",
	PY: "PY",
	QA: "QA",
	RE: "RE",
	RO: "RO",
	RS: "RS",
	RU: "RU",
	RW: "RW",
	SA: "SA",
	SB: "SB",
	SC: "SC",
	SD: "SD",
	SE: "SE",
	SG: "SG",
	SH: "SH",
	SI: "SI",
	SJ: "SJ",
	SK: "SK",
	SL: "SL",
	SM: "SM",
	SN: "SN",
	SO: "SO",
	SR: "SR",
	SS: "SS",
	ST: "ST",
	SV: "SV",
	SX: "SX",
	SY: "SY",
	SZ: "SZ",
	TC: "TC",
	TD: "TD",
	TF: "TF",
	TG: "TG",
	TH: "TH",
	TJ: "TJ",
	TK: "TK",
	TL: "TL",
	TM: "TM",
	TN: "TN",
	TO: "TO",
	TR: "TR",
	TT: "TT",
	TV: "TV",
	TW: "TW",
	TZ: "TZ",
	UA: "UA",
	UG: "UG",
	UM: "UM",
	US: "US",
	UY: "UY",
	UZ: "UZ",
	VA: "VA",
	VC: "VC",
	VE: "VE",
	VG: "VG",
	VI: "VI",
	VN: "VN",
	VU: "VU",
	WF: "WF",
	WS: "WS",
	XK: "XK",
	YE: "YE",
	YT: "YT",
	ZA: "ZA",
	ZM: "ZM",
	ZW: "ZW"
};
//#endregion
export { r as C, t as E, i as S, n as T, I as _, ee as a, s as b, W as c, q as d, B as f, U as g, L as h, $ as i, G as l, R as m, ne as n, z as o, V as p, te as r, H as s, re as t, K as u, a as v, l as w, o as x, c as y };
